import config from 'garaje/config/environment';
import Mirage from 'miragejs';
import { faker } from '@faker-js/faker';

export default function () {
  this.urlPrefix = config.roomsHost;
  // **************************************************************************
  // Company configs
  // **************************************************************************
  this.get('/a/rooms-v2/api/v1/company-configs/:id');
  this.patch('/a/rooms-v2/api/v1/company-configs/:id');

  // **************************************************************************
  // Connections
  // **************************************************************************
  this.get('/a/rooms-v2/api/v1/connections');
  this.get('/a/rooms-v2/api/v1/connections/:id');
  this.post('/a/rooms-v2/api/v1/connections');
  this.delete('/a/rooms-v2/api/v1/connections/:id');

  // **************************************************************************
  // Devices
  // **************************************************************************
  this.delete('/a/rooms-v2/api/v1/devices/:id', ({ roomDevices }, request) => {
    const device = roomDevices.find(request.params.id);
    return device.destroy();
  });

  // **************************************************************************
  // Rooms
  // **************************************************************************
  this.get('/a/rooms-v2/api/v1/rooms');
  this.get('/a/rooms-v2/api/v1/rooms/:id');
  this.patch('/a/rooms-v2/api/v1/rooms/:id');

  // **************************************************************************
  // Rooms Location Config
  // **************************************************************************
  this.post('/a/rooms-v2/api/v2/room-location-configs');
  this.get('/a/rooms-v2/api/v2/room-location-configs/:id');
  this.patch('/a/rooms-v2/api/v2/room-location-configs/:id');

  // **************************************************************************
  // Landing page
  // **************************************************************************
  this.get('/a/roomba/analytics/rooms-landing-page/:location_id', function (_schema, _request) {
    return new Mirage.Response(
      200,
      {},
      {
        data: {
          'auto-released': faker.number.int({ min: 0, max: 84 }),
          'auto-released-change': faker.number.int({ min: -88, max: 260 }),
          booked: faker.number.int({ min: 0, max: 84 }),
          'booked-change': faker.number.int({ min: -88, max: 260 }),
        },
      }
    );
  });
  this.get('/a/roomba/onboarding_status', function (_schema, _request) {
    return new Mirage.Response(
      200,
      {},
      {
        value: {
          has_calendar: true,
          assigned_locations: true,
          paired_rooms: true,
        },
      }
    );
  });

  // **************************************************************************
  // Active rooms count
  // **************************************************************************
  this.get('/a/roomba/billing/status', function (schema, request) {
    const activeRooms = schema.rooms.where({ active: true, companyConfigId: request.queryParams.company_id }).models;
    const locations = schema.locations.where({ companyId: request.queryParams.company_id }).models;
    const activeRoomsPerLocation = locations.reduce((result, location) => {
      result[location.id] = activeRooms.filterBy('locationId', location.id).length;
      return result;
    }, {});

    return new Mirage.Response(
      200,
      {},
      {
        company_id: request.queryParams.company_id,
        is_active: true,
        num_active_rooms: activeRooms.length,
        num_active_rooms_per_location: activeRoomsPerLocation,
      }
    );
  });

  // **************************************************************************
  // Rooms Calendar Permissions Check
  // **************************************************************************
  this.post('/a/rms/api/v2/calendar_permissions/:id', function (schema, request) {
    return new Mirage.Response(
      200,
      {},
      {
        jsonapi: { version: '1.0' },
        data: {
          type: 'rooms',
          id: request.params.id,
          attributes: {
            'calendar-write-permission': true,
            'calendar-read-permission': true,
            'calendar-permissions-checked-at': new Date().toISOString(),
          },
        },
      }
    );
  });
}
